import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts";

Html.registerWidget('widget/specific/eventautocomplete',{initDom})

function initDom(obj: HTMLElement): void {
  const input = obj as HTMLInputElement | HTMLTextAreaElement;
  const form = input.form as HTMLFormElement & {
    description: HTMLInputElement | HTMLTextAreaElement;
    where: HTMLInputElement | HTMLTextAreaElement;
    color: HTMLInputElement | HTMLSelectElement;
    calendarId: HTMLInputElement | HTMLSelectElement;
  };

  if (!form) return;

  const timetable = FwDatas.get(form.calendarId.value);

  input.addEventListener('input', (evt) => {
    const orig = evt as InputEvent;

    if (
      (orig.inputType === undefined && orig.data === undefined) ||
      orig.inputType === 'insertReplacementText'
    ) {
      const match = timetable.suggestions.find(
        (s: { text: string }) => s.text.localeCompare(input.value) === 0
      );

      if (match) {
        form.description.value = match.description ?? '';
        form.where.value = match.where ?? '';
        form.color.value = match.color ?? '';
        form.color.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}
